import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Sidebar } from '../../shared/components/sidebar/sidebar';
import { DashboardHeader } from '../../shared/components/dashboard-header/dashboard-header';
import { DiagnocatFloatingStatusComponent } from '../../shared/components/diagnocat-floating-status/diagnocat-floating-status';
import { DioFloatingStatusComponent } from '../../shared/components/dio-floating-status/dio-floating-status';

import { PlanBanner } from '../../shared/components/plan-banner/plan-banner';

@Component({
  selector: 'app-dashboard-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, Sidebar, DashboardHeader, DiagnocatFloatingStatusComponent, DioFloatingStatusComponent, PlanBanner],
  templateUrl: './dashboard-layout.html',
  styleUrl: './dashboard-layout.css'
})
export class DashboardLayout {}
